import { useEffect } from 'react';

import { useAuth } from '@clerk/clerk-react';
import { getRouteApi, useNavigate } from '@tanstack/react-router';

import { BrandCard, LogoBrand } from '~/components/common';
import { PAGE_GRADIENT_BACKGROUND } from '~/components/common/pageBackground';
import { cn } from '~/lib/utils';
import { CustomSignIn } from '~/components/auth/CustomSignIn';

const routeApi = getRouteApi('/sign-in');

export function SignInPage() {
  const { isSignedIn } = useAuth();
  const navigate = useNavigate();
  const { returnUrl } = routeApi.useSearch();

  useEffect(() => {
    if (isSignedIn) {
      void navigate({ to: returnUrl || '/' });
    }
  }, [isSignedIn, navigate, returnUrl]);

  return (
    <div
      className={cn(
        'relative flex min-h-screen flex-col items-center justify-center p-4',
        PAGE_GRADIENT_BACKGROUND
      )}
    >
      <style>{`@keyframes signInFadeInUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }`}</style>
      <div className="w-full max-w-[420px] animate-[signInFadeInUp_0.5s_ease-out] motion-reduce:animate-none">
        {/* Header with Logo */}
        <div className="mb-10 text-center">
          <LogoBrand size="large" className="mb-3 justify-center" />

          {/* Tagline - Terminal Style */}
          <p className="font-mono text-[12px] font-medium tracking-[0.1em] text-muted-foreground uppercase">
            // The Inbox for Your AI
          </p>
        </div>

        {/* Sign-in Card */}
        <BrandCard accent="top" className="p-6 sm:p-8">
          <CustomSignIn />
        </BrandCard>

        {/* Footer - Security Message */}
        <div className="mt-8 text-center">
          <p className="font-mono text-[11px] font-medium tracking-[0.08em] text-muted-foreground-2 uppercase">
            Encrypted &bull; Secure &bull; Private
          </p>
        </div>
      </div>
    </div>
  );
}
